var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioOn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.4C15 28.3704 19.0296 32.4 24 32.4M24 32.4C25.0518 32.4 26.0616 32.22 27 31.8882C28.1675 31.5923 30.8522 30.2003 32.2512 27C32.7467 25.8646 33.0017 24.6388 33 23.4M24 32.4V36M28.2 24V16.2C28.2 15.6484 28.0914 15.1023 27.8803 14.5927C27.6692 14.0832 27.3599 13.6202 26.9698 13.2302C26.5798 12.8401 26.1168 12.5308 25.6073 12.3197C25.0977 12.1086 24.5516 12 24 12C23.4484 12 22.9023 12.1086 22.3927 12.3197C21.8832 12.5308 21.4202 12.8401 21.0302 13.2302C20.6401 13.6202 20.3308 14.0832 20.1197 14.5927C19.9086 15.1023 19.8 15.6484 19.8 16.2V24C19.8 24.5516 19.9086 25.0977 20.1197 25.6073C20.3308 26.1168 20.6401 26.5798 21.0302 26.9698C21.4202 27.3599 21.8832 27.6692 22.3927 27.8803C22.9023 28.0914 23.4484 28.2 24 28.2C24.5516 28.2 25.0977 28.0914 25.6073 27.8803C26.1168 27.6692 26.5798 27.3599 26.9698 26.9698C27.3599 26.5798 27.6692 26.1168 27.8803 25.6073C28.0914 25.0977 28.2 24.5516 28.2 24Z",
    stroke: "#212121",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOn);
export default __webpack_public_path__ + "static/media/audio-on.cdcbcc9fe495e9a804def61165093116.svg";
export { ForwardRef as ReactComponent };